export default "/_next/static/images/middle_arrow-622778b6b165e57463bc3c489f6c5eeb.svg";